<template>
  <v-container class="h-100 pa-4" fluid>
    <v-row justify="center" class="h-100">
      <v-sheet class="bg-background flex-1-1 px-4" max-width="420">
        <router-link :to="{ name: 'Login' }"
          ><v-img class="mx-auto mb-4" :src="LOGO_HEADER" contain
        /></router-link>
        <div>An email was sent to your account to verify your email. Please check your email.</div>
        <router-link :to="{ name: 'Login' }">
          <v-btn block color="primary" class="rounded-lg mb-8" elevation="2" type="submit"
            >Return To Login</v-btn
          >
        </router-link>
      </v-sheet>
    </v-row>
  </v-container>
</template>
<script setup lang="ts">
import { LOGO_HEADER } from '@/helpers';
</script>
